import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { getProductByRegion } from '../../lib/apis'
import Loader from '../../components/loader'
import { Card, CardContent } from '../../components/ui/card'
import CustomButton from '../../components/customButton'
import { scrollToTop } from '../../lib/utils'

interface Data {
  departments: Array<{
    price_ranges: []
  }>;
  product_id: number;
  product_name: string
}
function Departement() {
  const { idRegion } = useParams()
  const token = localStorage.getItem("token")
  const userId = localStorage.getItem("user")
  const [indexActive, setIndexActive] = useState(0)
  const [dataShow, setDataShow] = useState<Data>(
    {
      departments: [{
        price_ranges: []
      }],
      product_id: 0,
      product_name: "",
    }
  )
  const [loading, setLoading] = useState(true)
  const [productsByDepartment, setProductsByDepartment] = useState([])
  const navigate = useNavigate();

  useEffect(() => {
    scrollToTop()
  }, [])

  const updateProducts = async () => {
    try {
      const { data } = await axios.get(`${getProductByRegion}/${userId}/region/${idRegion}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      console.log(data)
      setProductsByDepartment(data.result)
      setDataShow(data.result[0])
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    updateProducts()
    // eslint-disable-next-line
  }, [])
  const handleChange = (index: number) => {
    setIndexActive(index)
    setDataShow(productsByDepartment[index])
  }
  return (
    <div className=' w-full  bg-gray-100 p-8 '>
      <div className=' flex flex-col justify-center items-center font-semibold mb-6'>
        <div className='text-3xl'> Vos souscriptions</div>
        <div className='mt-5 flex flex-row '>
          {
            loading ? <Loader /> :

              productsByDepartment.map((element: any, index: number) => {
                return (
                  <div
                    style={{
                      backgroundColor: indexActive === index ? "green" : "none",
                      padding: "10px",
                      borderRadius: "10px",
                      cursor: "pointer"
                    }}
                    onClick={() => handleChange(index)}
                  >
                    {element.product_name}
                  </div>
                )
              })
          }

        </div>
        <div className='mt-4 flex flex-wrap'>
          {!loading &&
            // eslint-disable-next-line
            dataShow.departments.map((item: any, index: number) => {
              return (
                <Card className="w-[400px]">
                  <CardContent className="p-5 w-full">
                    <div className="flex flex-col py-8">
                      <div className=" text-2xl text-center mb-4">
                        {item.department_name}
                      </div>

                      {/* <div style={{ fontWeight: "bold" }}>Nombre de produit {item.number_of_product}</div> */}
                    </div>


                    {
                      dataShow.departments[0].price_ranges.map((element: any) => {
                        return (
                          <>
                            <div className="flex justify-between items-center">
                              <div className="flex gap-8 items-center">
                                <div className="flex flex-col gap-1 text-[15px] font-normal items-start ">
                                  <span>{element.price_range}</span>
                                  <span>{element.date}</span>
                                </div>
                              </div>

                            </div>
                            <div className="h-[1px] w-full bg-primary my-3"></div>
                          </>

                        )
                      })
                    }
                    <div className="flex justify-center py-5">
                      <CustomButton
                        rounded
                        className="bg-primary text-white px-4 py-2"
                        onClick={() => navigate(`departement/${item.region_id}`, { state: item })}
                      >
                        <span className="text-[11px]">détail par départment</span>
                      </CustomButton>
                    </div>
                  </CardContent>
                </Card>
              )
            })
          }
        </div>
      </div>
    </div>
  )
}

export default Departement
